export default [
  {
    path: '/swaps',
    name: 'swaps',
    component: () => import('./ScaleSwaps.vue'),
    meta: {
      requiresAuth: true,
      is_admin: true,
      name: 'Trocas de Escalas',
    },
  },
]
